/* unplugin-vue-components disabled */import { render } from "./Head.vue?vue&type=template&id=27fd0f54&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=27fd0f54&lang=scss&scoped=true"
import "./Head.vue?vue&type=style&index=1&id=27fd0f54&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fd0f54"]])

export default __exports__